module.exports = __webpack_public_path__ + "img/gfj.71a30919.gif";